import { cn } from "@gymflow/helpers";
import { ReactNode } from "react";

import { CheckIcon } from "../icons/CheckIcon";

export type CheckboxInputProps = {
  onChange: (value: boolean) => void;
  checked?: boolean;
  name?: string;
  label?: string | ReactNode;
  containerClassName?: string;
};

export const CheckboxInput = ({
  onChange,
  checked,
  label,
  containerClassName,
  ...props
}: CheckboxInputProps) => (
  <div className={cn("flex items-center gap-3", containerClassName)}>
    <div className="relative size-5">
      <input
        type="checkbox"
        className="size-5 !min-h-0 !min-w-0"
        onChange={() => {
          onChange(!checked);
        }}
        checked={checked}
        {...props}
      />
      <div
        className={cn(
          "pointer-events-none absolute left-0 top-0 flex h-5 w-5 items-center justify-center rounded-md",
          {
            "bg-secondary-500": checked,
            "bg-gray-0 border-gray-300 border": !checked,
          },
        )}
      >
        {checked && (
          <CheckIcon
            pathClassName="stroke-gray-0 stroke-2"
            className="size-4"
          />
        )}
      </div>
    </div>
    {label && (
      <div className="dark:text-gray-0 m-0 block text-base font-medium text-gray-950">
        {label}
      </div>
    )}
  </div>
);
